module.exports = __webpack_public_path__ + "img/analysisIcon1.3f5cc522.png";